import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AboutUs from '../views/AboutUs.vue'
import Products from '../views/Products.vue'
import Events from '../views/Events.vue'
import ContactUs from '../views/ContactUs.vue'
import LogIn from '../views/LogIn.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },{
    path: '/about',
    name: 'AboutUs',
    component: AboutUs
  },{
     path: '/products',
    name: 'Products',
    component: Products
  },{
     path: '/events',
    name: 'Events',
    component: Events
  },{
    path: '/contactus',
    name: 'ContactUs',
    component: ContactUs
  },{
     path: '/login',
    name: 'LogIn',
    component: LogIn
  }
]

const router = new VueRouter({
  mode: 'history',
  // base:'/erp/',
  //  base: '/qinyuan/',
  routes, 
     scrollBehavior: () => ({ x: 0, y: 0 })
  
})

export default router